<!-- Header -->
 <mat-card>
  <mat-card-header>
    <div class="header-container">
      <div class="left-content">
        <lib-key [hierarchyItem]="selectiveData.masterKey"> </lib-key>
        <span class="header-text">Move Key(s)</span>
      </div>
      <button mat-icon-button class="close-button" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-header>
</mat-card>

<!-- Content -->
  <mat-card-content class="margin padding all">
    <form [formGroup]="moveForm" (keydown.enter)="onFormEnter($event)">
      <div class="row">
        <p>Enter individual keys separated by a comma.</p>
      </div>
      <!-- Key Names -->
      <div class="row">
        <mat-form-field floatLabel="always" appearance="outline" class="full-width">
          <mat-label
            for="keySetSymbols"
            [ngClass]="{
              'error-message': fieldHasError(moveForm, 'keySetSymbols'),
              focus: focus.keySetSymbols
            }"
          >
            Key Names
          </mat-label>

            <input
              id="keySetSymbols"
              class="uppercase"
              [ngClass]="{
            error: fieldHasError(moveForm, 'keySetSymbols'),
            disabled: false,
              'focus-border': focus.keySetSymbols
            }"
              placeholder="Enter Key Names"
              formControlName="keySetSymbols"
              autocomplete="off"
              (focus)="focusOn('keySetSymbols')"
              (focusout)="focusOn('keySetSymbols')"
              aria-describedby="keySetSymbols errors"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(moveForm, 'keySetSymbols')" [size]="24" [color]="'#EE6352'">warning
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.keySetSymbols" id="keySetSymbolsErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(moveForm, validation, 'keySetSymbols')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>
      <div class="row">
        <p>Or enter groups of keys by range:</p>
      </div>
      <div class="row">
        <!-- Prefix -->

        <mat-form-field floatLabel="always" appearance="outline" class="quarter-width margin lrg right">
          <mat-label
            for="prefix"
            [ngClass]="{
              'error-message': fieldHasError(moveForm, 'prefix'),
              focus: focus.prefix
            }"
          >
            Prefix
          </mat-label>
            <input
              id="prefix"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(moveForm, 'prefix'),
              disabled: false,
              'focus-border': focus.prefix
            }"
              placeholder="Prefix"
              formControlName="prefix"
              (focus)="focusOn('prefix')"
              (focusout)="focusOn('prefix')"
              aria-describedby="prefix errors"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(moveForm, 'prefix')" [size]="24" [color]="'#EE6352'">warning
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.prefix" id="prefixErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(moveForm, validation, 'prefix')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
     

      <!-- from -->
        <mat-form-field floatLabel="always" appearance="outline" class="quarter-width margin lrg left right">
            <mat-label
              for="from"
              [ngClass]="{
                'error-message': fieldHasError(moveForm, 'from'),
                focus: focus.from
              }"
            >
              From <span *ngIf="lasSKD?.keySetSymbol">( Last used: {{ lasSKD?.keySetSymbol }} )</span>
            </mat-label>


            <input
              id="from"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(moveForm, 'from'),
              disabled: false,
              'focus-border': focus.from
            }"
              maxlength="{{ max }}"
              placeholder="From"
              formControlName="from"
              (focus)="focusOn('from')"
              (focusout)="focusOn('from')"
              aria-describedby="from errors"
              matInput
            />

            <mat-icon *ngIf="fieldHasError(moveForm, 'from')" [size]="24" [color]="'#EE6352'">warning
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.from" id="fromErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(moveForm, validation, 'from')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>


      <!-- to -->
        <mat-form-field floatLabel="always" appearance="outline" class="quarter-width margin lrg left right">
            <mat-label
              for="to"
              [ngClass]="{
                'error-message': fieldHasError(moveForm, 'to'),
                focus: focus.to
              }"
            >
              To
            </mat-label>
            <input
              id="to"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(moveForm, 'to'),
              disabled: false,
              'focus-border': focus.to
            }"
              maxlength="{{ max }}"
              placeholder="To"
              formControlName="to"
              (focus)="focusOn('to')"
              (focusout)="focusOn('to')"
              aria-describedby="to errors"
              min="0"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(moveForm, 'to')" [size]="24" [color]="'#EE6352'">warning
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.to" id="toErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(moveForm, validation, 'to')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>


      <!-- Suffix -->
        <mat-form-field floatLabel="always" appearance="outline" class="margin lrg left right">
            <mat-label
              for="suffix"
              [ngClass]="{
                'error-message': fieldHasError(moveForm, 'suffix'),
                focus: focus.suffix
              }"
            >
              Suffix
            </mat-label>
            <input
              id="suffix"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(moveForm, 'suffix'),
              disabled: false,
              'focus-border': focus.suffix
              }"
              placeholder="Suffix"
              formControlName="suffix"
              (focus)="focusOn('suffix')"
              (focusout)="focusOn('suffix')"
              aria-describedby="suffix errors"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(moveForm, 'suffix')" [size]="24" [color]="'#EE6352'">warning
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.suffix" id="suffixErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(moveForm, validation, 'suffix')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>

      <!---Independent Systems --->
      <div class="row">
        <mat-form-field floatLabel="always" appearance="outline" class="half-width margin lrg right">
            <mat-label
              for="targetKeySystemName"
              [ngClass]="{
                'error-message': fieldHasError(moveForm, 'targetKeySystemName'),
                focus: focus.targetKeySystemName
              }"
            >
              Independent Systems
            </mat-label>
            <mat-select [ngClass]="{
              'error' : fieldHasError(moveForm, 'targetKeySystemName'),
              'focus-border' : focus.targetKeySystemName
            }" (focus)="focusOn('targetKeySystemName')" (focusout)="focusOn('targetKeySystemName')"
            matNativeControl
            class="max-width"
            placeholder="Select System"
            formControlName="targetKeySystemName"
            [(value)]="selectedIndSystem"
            (selectionChange)="setFormIndSystem()">
            <mat-option [value]="'New'" (click)="checkFormRequirements()">
              New
            </mat-option>
            <mat-option *ngFor="let indSystem of indSystemList" [value]="indSystem">
              {{ indSystem.topMasterKeyName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      <!---Move To --->
        <mat-form-field floatLabel="always" appearance="outline"
          [ngClass]="{
            'half-width margin lrg left right': true,
            'mat-form-field-invalid': fieldHasInvalidSelectionError(moveForm, 'masterKeySetSymbol')
          }">
            <mat-label
              for="masterKeySetSymbol"
              [ngClass]="{
                'error-message': fieldHasInvalidSelectionError(moveForm, 'masterKeySetSymbol'),
                focus: focus.masterKeySetSymbol
              }"
            >
              Move To
            </mat-label>
            <input
              id="masterKeySetSymbol"
              class="uppercase"
              [ngClass]="{
                error: fieldHasInvalidSelectionError(moveForm, 'masterKeySetSymbol'),
                disabled: false,
                'focus-border': focus.masterKeySetSymbol
              }"
              placeholder="Select Destination"
              formControlName="masterKeySetSymbol"
              (focus)="focusOn('masterKeySetSymbol')"
              (focusout)="focusOn('masterKeySetSymbol'); validateMasterKeySelection()"
              (input)="onMasterKeyInput()"
              (keydown)="onMasterKeyKeydown($event)"
              aria-describedby="masterKeySetSymbol errors"
              matInput
              [matAutocomplete]="autoMasterKey"
            />
            <mat-autocomplete
              #autoMasterKey="matAutocomplete"
              [displayWith]="displayMasterKey.bind(this)"
              (optionSelected)="onMasterKeySelected()"
              (optionActivated)="onOptionActivated($event)"
            >
              <mat-option *ngFor="let masterKey of filteredMasterKeys$ | async" [value]="masterKey.keySetSymbol">
                {{ masterKey.keySetSymbol === 'convert to tmk' ? 'Convert To TMK' : masterKey.keySetSymbol }}
              </mat-option>
            </mat-autocomplete>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.masterKeySetSymbol" id="masterKeySetSymbolErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(moveForm, validation, 'masterKeySetSymbol') && moveForm.controls.masterKeySetSymbol.value" style="display: flex; align-items: center; gap: 4px;">
              <mat-icon [size]="24" [color]="'#EE6352'">warning</mat-icon>
              <span>{{ validation.message }}</span>
            </div>
          </div>
        </mat-form-field>
      </div>

      <!---TMK Combination--->
      <div *ngIf="moveForm.controls.targetKeySystemName.value !== 'New' && moveForm.controls.masterKeySetSymbol.value === 'convert to tmk'" class="row">
        <mat-form-field floatLabel="always" appearance="outline" class="half-width margin lrg right">
            <mat-label
              for="tmkBitting"
              [ngClass]="{
                'error-message': fieldHasError(moveForm, 'tmkBitting'),
                focus: focus.tmkBitting
              }"
            >
              TMK Combination
            </mat-label>
            <input
              id="tmkBitting"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(moveForm, 'tmkBitting'),
              disabled: false,
              'focus-border': focus.tmkBitting
            }"
              placeholder="Enter TMK Combination"
              formControlName="tmkBitting"
              (focus)="focusOn('tmkBitting')"
              (focusout)="focusOn('tmkBitting')"
              aria-describedby="tmkBitting errors"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(moveForm, 'tmkBitting')" [size]="24" [color]="'#EE6352'">warning
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.tmkBitting" id="tmkBittingErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(moveForm, validation, 'tmkBitting')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>

      <!---Keyway--->
        <mat-form-field floatLabel="always" appearance="outline" class="half-width margin lrg left right">
            <mat-label
              for="keySectionId"
              [ngClass]="{
                'error-message': fieldHasError(moveForm, 'keySectionId'),
                focus: focus.keySectionId
              }"
            >
              Key Section
            </mat-label>
            <mat-select [ngClass]="{
              'error' : fieldHasError(moveForm, 'keySectionId'),
              'focus-border' : focus.keySectionId
            }" (focus)="focusOn('keySectionId')" (focusout)="focusOn('keySectionId')"
            matNativeControl
            class="max-width"
            placeholder="Select Key Section"
            formControlName="keySectionId">
            <mat-option *ngFor="let keySection of keySectionList" [value]="keySection">
              {{ keySection.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </form>
  </mat-card-content>

<!-- Buttons -->
<mat-card-actions>
  <div class="row">
    <button mat-stroked-button id="cancel" (click)="close()"> Cancel </button>
    <button
    mat-flat-button
      class="margin left"
      color="primary"
      id="save"
      (click)="checkAssignedKeyCombinations()"
      [disabled]="!moveForm.valid"
    >
      Confirm
    </button>
  </div>
</mat-card-actions> 
